import NewsletterSubscriber from './Models/NewsletterSubscriber'

Vue.prototype.$models.$newsletterSubscriber = new Vue(NewsletterSubscriber)

Vue.component('newsletter-subscribers-table', () => import(/* webpackChunkName: "newsletter-subscribers-table" */ '@modulesPages/Newsletter/Resources/assets/js/Tables/NewsletterSubscribersTable'))

Vue.component('newsletter-subscribers-form', () => import(/* webpackChunkName: "newsletter-subscribers-form" */ '@modulesPages/Newsletter/Resources/assets/js/Forms/NewsletterSubscribers/NewsletterSubscribersForm'))


app.$Util.formattedClassName = {
    ...app.$Util.formattedClassName,
    ...{
        'Modules\\Newsletter\\Entities\\NewsletterSubscriber': 'Subscriptor',
    }   
}

app.$Util.tableNameByClassName = {
    ...app.$Util.tableNameByClassName,
    ...{
        'Modules\\Newsletter\\Entities\\NewsletterSubscriber': 'newsletter_subscribers',
    }   
}

app.$Util.classNameByTableName = {
    ...app.$Util.classNameByTableName,
    ...{
        'newsletter_subscribers': 'Modules\\Newsletter\\Entities\\NewsletterSubscriber',
    }   
}